module.exports = __webpack_public_path__ + "img/undraw_Partying_re_at7f.a437db15.svg";